<div class="map-container" [ngStyle]="{ height: mapHeight() }">
  <div class="map-frame">
    <div id="leaflet-map"></div>
  </div>
</div>
